(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-claim/assets/bubble-background.js') >= 0) return;  svs.modules.push('/modules/tickets-claim/assets/bubble-background.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  PI
} = Math;
const MAX_BUBBLES = Math.round(window.innerHeight / 100);
const BUBBLE_RADIUS_BASE = 25;
const scaleFactor = svs.core.detect.breakpoint.greaterThan('sm') ? 400 : 150;
const distances = [0, 1, 2, 3, 4];
const alpha = {
  0: 1,
  1: 0.8,
  2: 0.7,
  3: 0.6,
  4: 0.5
};
const gradientColors = {
  skrapkryss: {
    startColor: '#F9B61D',
    stopColor: '#EA7901'
  },
  skrapbingo: {
    startColor: '#7CC4E3',
    stopColor: '#269DCD'
  },
  skrapmatcha: {
    startColor: '#CE82B8',
    stopColor: '#BE5BA2'
  },
  skrapkeno: {
    startColor: '#F37D32',
    stopColor: '#E51A18'
  },
  skraplotto: {
    startColor: '#37A833',
    stopColor: '#005500'
  },
  skrap7an: {
    startColor: '#bbe5ce',
    stopColor: '#66CDC0'
  },
  default: {
    startColor: '#FFFFFF',
    stopColor: '#D4D4D9'
  }
};
class BubbleBackground extends React.Component {
  constructor(props) {
    super(props);
    this.canvasRef = React.createRef();
    this.frameCounterRef = React.createRef();
    this.renderFrame = this.renderFrame.bind(this);
    this.eachBubble = this.eachBubble.bind(this);
    this.setCanvasSize = this.setCanvasSize.bind(this);
    this.frameCount = 0;
    this.bubbles = [];
    this.avalibleSpots = [];
    this.availableSizes = [];
  }
  static getDerivedStateFromProps(nextProps) {
    nextProps.ticketType && this.bubbles.forEach(bubble => {
      bubble.ticketType = nextProps.ticketType.toLowerCase();
    });
  }
  componentDidMount() {
    this.canvasCtx = this.canvasRef.current.getContext('2d');
    this.setCanvasSize();
    for (let i = 0; i < MAX_BUBBLES; i++) {
      this.createBubble(i);
    }
    requestAnimationFrame(() => {
      this.renderFrame();
    });
    window.addEventListener('resize', _.debounce(this.setCanvasSize, 50));
  }
  setCanvasSize() {
    this.canvasCtx.canvas.width = window.innerWidth;
    this.canvasCtx.canvas.height = window.innerHeight;
    this.avalibleSpots = [];
    this.availableSizes = [];
    const maxRadius = BUBBLE_RADIUS_BASE * (window.innerWidth / scaleFactor);
    const nbAvalibleSpots = MAX_BUBBLES * 2;
    for (let i = 0; i < nbAvalibleSpots; i++) {
      const space = window.innerWidth / nbAvalibleSpots;
      this.avalibleSpots.push(Math.round(space * i) + 1);
      const size = maxRadius / nbAvalibleSpots;
      this.availableSizes.push(Math.round(size * (i + 1)));
    }
    this.avalibleSpots = _.shuffle(this.avalibleSpots);
    this.availableSizes = _.shuffle(this.availableSizes);
  }
  createBubble(bubbleIndex) {
    const bubble = {
      pos: {},
      isNew: true
    };
    if (!this.props.ticketType) {
      const selection = Object.keys(gradientColors).filter(k => k !== 'default');
      bubble.ticketType = selection[bubbleIndex % selection.length];
    } else {
      bubble.ticketType = this.props.ticketType;
    }
    this.resetBubble(bubble, true);
    this.bubbles.push(bubble);
  }
  updateBubble(bubble) {
    if (bubble.pos.y > -bubble.radius) {
      const wobble = Math.sin((this.frameCount + bubble.seed) / 25) * 10 / Math.max(bubble.radius / 1.4, 30);
      bubble.pos.y += bubble.velocity;
      bubble.pos.x += wobble;
    } else {
      this.resetBubble(bubble);
    }
  }
  resetBubble(bubble, isNewBubble) {
    if (isNewBubble) {
      bubble.radius = this.availableSizes.shift();
      bubble.pos.y = _.random(bubble.radius, window.innerHeight + bubble.radius);
    } else {
      this.avalibleSpots.push(bubble.startPos);
      this.availableSizes.push(bubble.radius);
      bubble.radius = this.availableSizes.shift();
      bubble.pos.y = window.innerHeight + bubble.radius;
    }
    bubble.distance = _.sample(distances);
    const startPos = this.avalibleSpots.shift();
    bubble.seed = Math.floor(Math.random() * 1000);
    bubble.startPos = startPos;
    bubble.pos.x = startPos;
    const maxRadius = BUBBLE_RADIUS_BASE * (window.innerWidth / scaleFactor);
    bubble.velocity = -((maxRadius - bubble.radius) / 200 + 0.2);
    this.bubbles = this.bubbles.sort((a, b) => a.distance < b.distance);
  }
  renderFrame() {
    this.frameCount++;
    const {
      canvasCtx
    } = this;
    canvasCtx.clearRect(0, 0, canvasCtx.canvas.width, canvasCtx.canvas.height);
    this.bubbles.forEach(this.eachBubble);
    requestAnimationFrame(this.renderFrame);
  }
  eachBubble(bubble) {
    const {
      canvasCtx
    } = this;
    this.updateBubble(bubble);
    canvasCtx.beginPath();
    canvasCtx.arc(bubble.pos.x, bubble.pos.y, bubble.radius, 0, 2 * PI);
    canvasCtx.fillStyle = bubble.gradient;
    canvasCtx.globalAlpha = this.props.ticketType ? alpha[bubble.distance] : alpha[bubble.distance] - 0.5;
    const dim = bubble.radius / 2;
    const px = Math.floor(bubble.pos.x);
    const py = Math.floor(bubble.pos.y);
    const {
      startColor,
      stopColor
    } = _objectSpread(_objectSpread({}, gradientColors.default), gradientColors[bubble.ticketType]);
    const gradient = this.canvasCtx.createLinearGradient(px - dim, py - dim, px + dim, py + dim);
    gradient.addColorStop(0, startColor);
    gradient.addColorStop(1, stopColor);
    bubble.gradient = gradient;
    canvasCtx.fill();
  }
  render() {
    return React.createElement("div", {
      className: "".concat(this.props.ticketType || 'default', " bubble-wrapper")
    }, React.createElement("canvas", {
      className: "bubble-background",
      ref: this.canvasRef
    }));
  }
}
setGlobal('svs.ticketsClaim.BubbleBackground', BubbleBackground);

 })(window);